import { forwardRef, memo, type ReactNode } from 'react'
import Typography, { type TypographyProps } from '@mui/material/Typography'
import type { ErrorLike } from 'types'
import { getErrorMessage } from 'lib/helpers/getErrorMessage/getErrorMessage'
import * as $ from './EmptyView.styled'

export interface EmptyViewProps extends Pick<React.ComponentProps<typeof $.Root>, 'id' | 'variant' | 'sx'> {
  children: ReactNode
  error?: Maybe<ErrorLike>
  icon?: ReactNode
  action?: ReactNode
  'data-testid'?: string
  slotProps?: {
    typography: TypographyProps
  }
}

export const EmptyView = memo<EmptyViewProps>(
  forwardRef<HTMLDivElement, EmptyViewProps>(
    ({ id, icon, action, variant = 'default', children, slotProps, error, ...props }, ref) => {
      return (
        <$.Root ref={ref} data-testid={id} variant={variant} {...props}>
          {icon && <$.Icon variant={variant}>{icon}</$.Icon>}
          <Typography variant="body1" align="center" {...slotProps?.typography}>
            {getErrorMessage(error) || children}
          </Typography>
          {action && <$.Action>{action}</$.Action>}
        </$.Root>
      )
    },
  ),
)

EmptyView.displayName = 'EmptyView'
